import { Row } from '@tanstack/react-table'
import { Pencil, Trash2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { RowActionBar, type RowAction } from '@/components/ui/row-action-bar'
import { useClients } from '../context/client-context'
import { Client } from '../data/schema'
import { useAuth } from '@/stores/authStore'
import { UserPermission } from '@/constants/permissions'

interface DataTableRowActionsProps {
  row: Row<Client>
}

export function DataTableRowActions({ row }: DataTableRowActionsProps) {
  const { t } = useTranslation()
  const { setOpen, setCurrentRow } = useClients()
  const { can } = useAuth()

  const actions: RowAction[] = [
    {
      key: 'edit',
      icon: <Pencil className="h-4 w-4" />,
      label: t('edit'),
      hidden: !can(UserPermission.CHANGE_CLIENT),
      onClick: () => {
        setCurrentRow(row.original)
        setOpen('edit')
      },
    },
    {
      key: 'delete',
      icon: <Trash2 className="h-4 w-4" />,
      label: t('delete'),
      destructive: true,
      hidden: !can(UserPermission.DELETE_CLIENT),
      onClick: () => {
        setCurrentRow(row.original)
        setOpen('delete')
      },
    },
  ]

  return <RowActionBar actions={actions} />
}
